// Fuzzball Quiz Constants
// All data constants and configuration in one place

window.QuizConstants = {
  // Breed list (weight data removed in Quiz 2.1 Phase 1)
  BREED_LIST: {
    "I don't know": {},
    "Abyssinian": {},
    "Aegean": {},
    "American Bobtail": {},
    "American Curl": {},
    "American Ringtail": {},
    "American Shorthair": {},
    "American Wirehair": {},
    "Aphrodite Giant": {},
    "Arabian Mau": {},
    "Asian Cat": {},
    "Asian Semi-longhair": {},
    "Australian Mist": {},
    "Aztec": {},
    "Balinese": {},
    "Bambino": {},
    "Bengal": {},
    "Birman": {},
    "Bombay": {},
    "Brazilian Shorthair": {},
    "British Longhair": {},
    "British Shorthair": {},
    "Burmese": {},
    "Burmilla": {},
    "Chantilly-Tiffany": {},
    "Chartreux": {},
    "Chausie": {},
    "Chinchilla": {},
    "Colourpoint Shorthair": {},
    "Cornish Rex": {},
    "Cymric": {},
    "Cyprus": {},
    "Devon Rex": {},
    "Domestic Long-hair": {},
    "Domestic Medium-hair": {},
    "Domestic Short-hair": {},
    "Donskoy": {},
    "Dragon Li": {},
    "Dwelf": {},
    "Egyptian Mau": {},
    "European Shorthair": {},
    "Exotic Shorthair": {},
    "Foldex": {},
    "German Rex": {},
    "Havana Brown": {},
    "Highlander": {},
    "Himalayan": {},
    "Japanese Bobtail": {},
    "Javanese": {},
    "Khao Manee": {},
    "Kinkalow": {},
    "Korat": {},
    "Kurilian Bobtail": {},
    "Lambkin": {},
    "LaPerm": {},
    "Lykoi": {},
    "Maine Coon": {},
    "Manx": {},
    "Mekong Bobtail": {},
    "Minskin": {},
    "Moggie": {},
    "Munchkin": {},
    "Napoleon": {},
    "Nebelung": {},
    "Norwegian Forest Cat": {},
    "Ocicat": {},
    "Ojos Azules": {},
    "Oregon Rex": {},
    "Oriental Bicolor": {},
    "Oriental Longhair": {},
    "Oriental Shorthair": {},
    "Persian": {},
    "Peterbald": {},
    "Pixie-bob": {},
    "Ragamuffin": {},
    "Ragdoll": {},
    "Russian Blue": {},
    "Sam Sawet": {},
    "Savannah": {},
    "Scottish Fold": {},
    "Selkirk Rex": {},
    "Serengeti": {},
    "Serrade Petit": {},
    "Siamese": {},
    "Siberian Forest Cat": {},
    "Singapura": {},
    "Snowshoe": {},
    "Sokoke": {},
    "Somali": {},
    "Sphynx": {},
    "Suffolk": {},
    "Thai": {},
    "Tiffanie": {},
    "Tonkinese": {},
    "Toyger": {},
    "Turkish Angora": {},
    "Turkish Van": {},
    "Turkish Vankedisi": {},
    "Ukranian Levkoy": {},
    "York Chocolate": {}
  },

  // Timing configuration
  TIMING: {
    BUNDLE_INIT_DELAY: 500,
    EDIT_MODE_RESTORE_DELAY: 1000,
    EDIT_MODE_RENDER_DELAY: 1500,
    DOM_CHECK_INTERVAL: 200,
    UI_UPDATE_DELAY: 100,
    RECHARGE_TIMEOUT: 10000,
    QUIZ_COMPLETE_DELAY: 1000,
    TAB_UPDATE_DELAY: 100,
    PRICE_UPDATE_DELAY: 1500,
    TRAIL_BOX_RESTORE_DELAY: 500,
    EXTRAS_POPUP_DELAY: 10,
    MODAL_HIDE_DELAY: 400,
    SUCCESS_MESSAGE_DURATION: 3000
  },

  // Default collection IDs
  COLLECTIONS: {
    DRY_FOOD: '282877034628',
    WET_FOOD: '282877001860',
    TREATS: '282974978180',
    LITTER: '282975010948'
  },

  // Food constants
  FOOD: {
    DAYS_PER_MONTH: 28,
    CANS_PER_PACK: 7,
    MAX_CANS_PER_MONTH: 196,
    MAX_PACKS: 28,
    MAX_BAGS_PER_MONTH: 4,
    TRIAL_BOX_PRICE: 8.00,
    SUBSCRIPTION_DELAY_DAYS: 12
  },

  // Trail box valid combinations
  TRAIL_BOX_GOALS: [
    ['can', 'can', 'can', 'can', 'dry'], // 4 cans + 1 dry
    ['can', 'can', 'can', 'can', 'can']  // 5 cans
  ],

  // Health concern messages
  HEALTH_MESSAGES: {
    'Cancer': 'Cats can sadly suffer from different types of cancer, and there may be specific nutritional requirements depending which kind they have. Have a chat with your vet but eating a complete diet, like Fuzzball, regularly to maintain a healthy body weight is suitable for most cats with cancer.',
    'Cardiac condition': 'Heart problems can be seen in any age of cats, and in most cases eating a complete, quality diet like Fuzzball will be suitable. However, chat with your vet about your cat\'s heart problem.',
    'Diabetes': 'Managing a cat with diabetes can be a juggle! Chat with your vet about a suitable diet but in general choosing a high protein food like Fuzzball\'s tinned food is recommended. Remember not to change your diabetic cat\'s diet without chatting to your veterinary team.',
    'Gastrointestinal disease': 'Many cats suffer from intestinal problems, causing vomiting and diarrhoea for example. Discuss appropriate diets with your vet, however, a complete good quality food like Fuzzball may be appropriate.',
    'Inflammatory bowel disease': 'Many cats suffer from intestinal problems, causing vomiting and diarrhoea for example. Discuss appropriate diets with your vet, however, a complete good quality food like Fuzzball may be appropriate.',
    'Hyperthyroidism': 'Hyperthyroidism, or an overactive thyroid, is quite common in older cats. There are various treatments, so have a chat with your vet, but Fuzzball would be a suitable complete diet for most affected cats.',
    'Joint Issues': 'Arthritis affects many of our senior felines, and Fuzzball is suitable as a complete diet. Chat to your vet about other therapies to keep your furbaby comfortable.',
    'Periodontal disease': 'Dental disease is common in cats and can be really painful! Speak to your vet but Fuzzball tinned food is nice and soft for cats with sore mouths.',
    'Chronic kidney disease': 'Chronic kidney disease affects older felines and often requires a special diet. Discuss the best thing to feed your cat with your vet. Fuzzball does not currently have a diet for cats with this condition.',
    'Skin & coat issues': 'Any sore, scurfy skin or loss of hair warrants a trip to the vet! Fuzzball is a complete, quality diet so as long as your cat is not on a prescription food for skin disease it should be suitable and contains all your cat needs for a glossy coat!',
    'Urinary condition': 'Urinary problems are common in cats and may require a special, prescription diet. In other cases, a complete diet like Fuzzball will be fine so discuss with your vet.',
    'Cystitis': 'Cystitis is an uncomfortable condition for cats. Chat to your vet about the most suitable diet, but the high moisture content of Fuzzball tins might help some cats.',
    'Diarrhoea': 'Many cats suffer from intestinal problems, causing vomiting and diarrhoea for example. Discuss appropriate diets with your vet, however, a complete good quality food like Fuzzball may be appropriate.',
    'Epilepsy': 'Epilepsy (fitting) is not common in cats thankfully and Fuzzball should be a suitable complete diet to feed to affected cats.',
    'Feline Asthmas': 'Cats get asthma too! Like humans it can cause a cough or shortness of breath needing veterinary treatment. Fuzzball is suitable to feed to cats with asthma.',
    'Liver disease': 'Liver diseases are complicated! For many cats it is important they eat a good quality complete diet like Fuzzball. Other cats may need a specific prescription diet so discuss with your veterinary team.',
    'Pancreatitis': 'Pancreatitis in cats can be complex, most cases need a good quality complete diet like Fuzzball but see your vet to talk about this.',
    'Anaemia': 'Anaemia occurs when your cat has a reduced number of red blood cells. Is has a variety of causes and Fuzzball will be a great complete food to feed for most of these but discuss with your vet.',
    'Vomiting': 'Many cats suffer from intestinal problems, causing vomiting and diarrhoea for example. Discuss appropriate diets with your vet, however, a complete good quality food like Fuzzball may be appropriate.',
    'Hypertension (high blood pressure)': 'Older cats can get high blood pressure, and it is often related to chronic kidney disease which may need a special diet. In other cases a quality complete diet like Fuzzball is fine to feed.'
  }
}; 